import { Component, OnInit } from '@angular/core';
import { DefaultFormDialogComponent } from '../../../message/dialogs/default-form-dialog.component';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaEventService } from '../../../services/ga-event.service';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { FormattingService } from '../../../services/formatting.service';
import { AuthService } from '../../../services/auth/auth.service';
import _ from 'underscore';
import { IDescribedStringObject, IObject } from '@type_definitions/datatypes';
import { Override } from '../../../app-decorators';
import { TranslationService } from '../../../translation/translation.service';
import { BPProfilesLocationsDataService } from '../../../bp-profiles/bp-profiles-locations-data.service';
import { util } from '@app/shared/util';

@Component({
  selector: 'set-default-oem-location-contact-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class SetDefaultOEMLocationContactActionComponent extends BaseReportActionsDialog implements OnInit {
  private locationField: IExtraFieldConfigurationObject;
  private contactField: IExtraFieldConfigurationObject;
  private overwriteField: IExtraFieldConfigurationObject;
  private bpProfileId: number;
  private companyId: number;

  private updateTypes: IDescribedStringObject[] = [
    { id: 'S', description: 'Shipping location and contact' },
    { id: 'I', description: 'Invoice location and contact' },
    { id: 'B', description: 'Both' }
  ];

  constructor(
    private formlyService: GaFormlyService,
    private bpProfilesLocationsDataService: BPProfilesLocationsDataService,
    private formattingService: FormattingService,
    private authService: AuthService,
    protected translationService: TranslationService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    this.saveButtonLabel = this.translationService.instant('GA.BUTTONS.SAVE');
    super.ngOnInit();

    this.model = {
      updateType: _.findWhere(this.updateTypes, { id: 'B' })
    };

    _.each(this.rowSelection, (rowSelection: IObject) => {
      this.bpProfileId = util.extractValue(rowSelection?.Deproid);
      this.companyId = util.extractValue(rowSelection?.Decomid);
    });

    // create fields
    this.fields = this.createFields();

    // trigger onChange for the first time
    this.onUpdateTypeChange(this.model.updateType);
  }

  @Override(DefaultFormDialogComponent)
  public getModel(): IObject {
    return {
      updateType: this.model?.updateType?.id,
      locationId: this.model?.location?.id,
      contactId: this.model?.contact?.id,
      isOverwrite: this.model?.isOverwrite || false
    };
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    const locationContactRequiredValidator: IObject = {
      expression: (): boolean => {
        return !_.isUndefined(this.model.contact) || !_.isUndefined(this.model.location);
      },
      message: 'Location or contact cannot be empty'
    };

    return [
      this.formlyService.aRadio('updateType', 'Update type')
        .withOptions(this.updateTypes)
        .withFormat(this.formattingService.formatDescription)
        .isRequired()
        .onChange(this.onUpdateTypeChange)
        .build(),
      this.locationField = this.formlyService.aSelect2('location', 'Default location')
        .isDisabled()
        .withExtraOptions({
          templateOptions: {
            parseHtml: true
          },
          validators: {
            locationContactRequired: locationContactRequiredValidator
          }
        })
        .onChange(this.onValidationUpdate)
        .withFormat(this.formattingService.formatLocationHtml)
        .build(),
      this.contactField = this.formlyService.aSearch('contact', 'Default contact')
        .isDisabled()
        .withUrl(this.authService.authenticatedUrl(`rest/bpprofiles/profiles/${this.bpProfileId}/companies/${this.companyId}/contacts`))
        .withFormat(this.formattingService.formatContact)
        .withExtraOptions({
          validators: {
            locationContactRequired: locationContactRequiredValidator
          }
        })
        .onChange(this.onValidationUpdate)
        .build(),
      this.overwriteField = this.formlyService.aCheckbox('isOverwrite', 'Overwrite existing location and contact')
        .isDisabled()
        .withoutWrapper()
        .withHint('If checked, it will updates all BP OEMs location and contact. If not checked, it will only updates BP OEMs missing location and contact')
        .showInfo()
        .withoutInfoOffset()
        .build()
    ];
  }

  private onUpdateTypeChange = (updateType: string): void => {
    this.locationField.templateOptions.disabled = !updateType;
    this.contactField.templateOptions.disabled = !updateType;
    this.overwriteField.templateOptions.disabled = !updateType;
    this.formlyService.fillField(this.locationField, this.bpProfilesLocationsDataService.getLocations(this.bpProfileId));
  };

  private onValidationUpdate = (): void => {
    this.locationField.formControl.updateValueAndValidity();
    this.contactField.formControl.updateValueAndValidity();
  };
}